/**
 * مفاتيح localStorage لتقدّم معالجات الإنشاء (coach marks).
 * مصدر واحد يُستخدم عند مسح الجلسة وتفضيلات المعالج الذكي.
 */
export const WIZARD_PROGRESS_STORAGE_KEYS: readonly string[] = [
  'branch_wizard_progress',
  'chart_accounts_wizard_progress',
  'company_wizard_progress',
  'contact_wizard_progress_CUSTOMERS',
  'contact_wizard_progress_VENDORS',
  'currency_wizard_progress',
  'daily_journal_wizard_progress',
  'electronic_invoice_wizard_progress',
  'financial_year_wizard_progress',
  'intermediate_account_wizard_progress',
  'manual_inventory_wizard_progress',
  'opening_stock_wizard_progress',
  'payment_voucher_wizard_progress',
  'pos_wizard_progress',
  'product_category_wizard_progress',
  'product_wizard_progress',
  'products_barcodes_wizard_progress',
  'purchase_invoice_wizard_progress',
  'receipt_voucher_wizard_progress',
  'roles_wizard_progress',
  'sales_invoice_wizard_progress',
  'shift_wizard_progress',
  'store_wizard_progress',
  'users_wizard_progress',
  'zatca_unit_wizard_progress',
];
